<button mat-icon-button class="user-avatar" [matMenuTriggerFor]="userDetails">
  <span>{{ initials }}</span>
</button>
<mat-menu #userDetails="matMenu" xPosition="before" class="user-menu">
<div class="menu-container">
  <div class="user-avatar-circle">
    <span>{{ initials }}</span>
  </div>
  <div class="user-details">
    <p class="user-name">{{ name }}</p>
    <p class="user-email">{{ username }}</p>
    <p class="user-role">{{ role }}</p>
  </div>
</div>

<button mat-button class="logout-button" (click)="onLogoutClick()">
  <span class="material-icons">logout</span> Logout
</button>
</mat-menu>